import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Feet() {
	return (
		<g>
			<path className="fill penguin--foot penguin--foot--left" d="M250.2910461,368.0740967c0,6.978302-10.0612946,6.6719666-22.4725189,6.6719666
				s-22.4725037,0.3063354-22.4725037-6.6719666s10.0612793-17.3981323,22.4725037-17.3981323
				S250.2910461,361.0957947,250.2910461,368.0740967z" />
			<path className="fill penguin--foot penguin--foot--right" d="M302.7102356,368.0657349c0,6.9870605-10.0739136,6.6803284-22.5007324,6.6803284
				s-22.5007324,0.3067322-22.5007324-6.6803284c0-6.9870911,10.0739136-17.4199829,22.5007324-17.4199829
				S302.7102356,361.0786438,302.7102356,368.0657349z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/TuxedoBird/Feet.js